import Helmet from 'react-helmet';

import {StoreProvider} from '~/store';
import {AuthListener} from '~/listeners';
import {SceneManager} from '~/navigation';
import {ENVIRONMENT} from '~/modules/config';

import {ToasterProvider} from '~/context/ToasterContext';

function GlobalListeners() {
  return (
    <>
      <AuthListener />
    </>
  );
}

export default function AppConnected() {
  return (
    <>
      <Helmet title={`${ENVIRONMENT} | Gertrude`}>
        <link
          type="text/css"
          rel="stylesheet"
          href="https://www.gstatic.com/firebasejs/ui/6.0.1/firebase-ui-auth.css"
        />
      </Helmet>
      <StoreProvider>
        <ToasterProvider>
          <SceneManager />
          <GlobalListeners />
        </ToasterProvider>
      </StoreProvider>
    </>
  );
}
